import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core'
import { deepcopy, removeToolTip } from 'src/app/_helpers/Utils'
import { Section } from 'src/app/models/HandlerOperation'
import { HandlerOperationService } from 'src/app/services/handler.operation.service'
import { NotificationService } from 'src/app/services/notification.service'

@Component({
	selector: 'app-sections',
	templateUrl: './sections.component.html'
})
export class SectionsComponent implements OnInit {

		@Input() public sections: Array<Section> = []
		@Input() public handlerOperationId: string = ''

		@Output() public close: EventEmitter<any> = new EventEmitter()
		@Output() public updateSections: EventEmitter<Array<Section>> = new EventEmitter()

		public sectionsFiltred: Array<Section> = []
		public editingSection: Section = new Section()
		public searchSection: string = ''

		public addNewSection: boolean = false
		public editSection: boolean = false

		constructor(
				public notificationService: NotificationService,
				private operationService: HandlerOperationService
		) {}

		public ngOnInit(): void {
				this.sectionsFiltred = this.sections
		}

		public openNewSection() {
				this.addNewSection = true
		}

		public closeNewSection() {
				this.addNewSection = false
		}

		public openEditSection(section: Section) {
				this.editingSection = deepcopy(section)
				this.editSection = true
		}

		public closeEditSection() {
				this.editSection = false
		}

		public filterSections() {
				if (this.searchSection) {
						this.sectionsFiltred = this.sections.filter(section => {
								const item = section.name.toLowerCase()
								const search = this.searchSection.toLowerCase()

								if (Boolean(item.includes(search))) {
								return section
								}
						})
				} else {
						this.sectionsFiltred = this.sections
				}
		}

		public async removeSection(sectionId: number) {
				if (this.handlerOperationId) {
						try {
								const response =
										await this.operationService.deleteSection(sectionId).toPromise()

								this.notificationService.notify(response, 200)
						} catch (error) {
								this.notificationService.notify(error.error.message || 'Erro ao remover o inciso', 400)

								return
						}
				}

				const sections =
						this.sections.filter(section => section.id !== sectionId)

				this.sections = sections
				this.sectionsFiltred = sections

				this.updateSections.emit(sections)
		}

		public async findSectionsFromHandlerOperation() {
				try {
						const sections =
								await this.operationService.findSectionsFromHandlerOperation(this.handlerOperationId).toPromise()

						this.sections = sections
						this.sectionsFiltred = sections
						this.updateSections.emit(sections)
				} catch (error) {
						this.notificationService.notify(error.error.message || 'Erro ao buscar incisos', 400)
				}
		}

		public getSectionForNewManagment(section: Section) {
				const index =
						this.sections.findIndex(item => item.id == section.id)

				if (index != -1) {
						this.sections.splice(index, 1, section)
				} else {
						this.sections.push(section)
				}
		}

		public closeSections() {
				this.close.emit()
				removeToolTip()
		}
}
